import { LOGOUT } from '../constants/authConstants';
import * as types from '../constants/usersConstants';

const initialState = {
  users: [],
  user: null,
  loading: true,
  pageable: {
    totalPages: 1,
    last: true,
    first: true,
    size: 0,
    number: 0,
    totalElements: 0,
  },
  search: {
    search: '',
    page: 0,
    size: 10,
  },
};

const usersReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT:
      return {
        ...initialState,
      };
    case types.CLEAR_USERS:
      return {
        ...initialState,
      };
    case types.CLEAR_SELECTED_USER:
      return {
        ...state,
        user: null,
      };
    case types.GET_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        users: payload.data,
        pageable: payload.pageable,
      };
    case types.GET_USERS_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case types.GET_USERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case types.SELECT_USER:
      return {
        ...state,
        user: {
          ...payload,
          roles: payload.roles.map((role) => String(role.id)),
        },
      };
    case types.SET_USERS_PAGE_SIZE:
      return {
        ...state,
        search: {
          ...state.search,
          page: 0,
          size: payload,
        },
      };
    case types.SET_USERS_SEARCH:
      return {
        ...state,
        search: {
          ...state.search,
          page: 0,
          search: payload,
        },
      };
    case types.NEXT_USERS_PAGE:
      return {
        ...state,
        search: {
          ...state.search,
          page: state.search.page + 1,
        },
      };
    case types.PREV_USERS_PAGE:
      return {
        ...state,
        search: {
          ...state.search,
          page: state.search.page - 1,
        },
      };
    default:
      return state;
  }
};

export default usersReducer;
